import { isDevMode, OnChanges } from '@angular/core';

export class DiagnosticsService {

    private services: any = {};
    private isUpdateAllowed: boolean = true;
    private isDev: boolean;
    private requests: any = [];
    private registrations: any = [];
    private timeoutId: any;
    private bench: any;

    constructor() {
        this.bench = +new Date();
        this.isDev = isDevMode();
        this.isUpdateAllowed = this.isDev;
    }

    get RegisteredServices() {
        return this.registrations;
    }

    public registerInstance(constructor: any) {
        this.log(constructor.name);
        this.queue("add", constructor);
    }

    public disposeInstance(constructor: any) {
        this.queue("remove", constructor);
    }

    private queue(type: string, constructor: any) {
        if (this.isDev) {
            this.requests.push({ type, constructor });
            this.scheduleCycle();
        }
    }

    delayUpdate() {
        if (!this.isUpdateAllowed) {
            this.scheduleCycle();
        }
    }

    private scheduleCycle() {
        this.log("------------------delay------------------");
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this.isUpdateAllowed = true;
            this.runCycle();
        }, 250);
    }

    private runCycle() {
        if (!this.isUpdateAllowed || !this.requests.length) return;
        this.isUpdateAllowed = false;
        this.log(`------------------cycle ${this.requests.length}------------------`);

        this.requests.forEach(x => {
            if (x.type === "add") {
                this.addInstance(x.constructor);
            } else {
                this.removeInstance(x.constructor);
            }
        });

        this.requests = [];
        this.updateRegistrations();

        this.delayUpdate();
    }

    private updateRegistrations() {
        this.registrations =
            Object.keys(this.services)
                .map(key => this.services[key])
                .sort((a, b) => (a.key || "").localeCompare(b.key));
        // .sort((a, b) => b.alive - a.alive);
    }

    log(s) {
        //var cur = +new Date();
        //console.log(cur - this.bench, s);
        //this.bench = cur;
    }

    private addInstance(constructor: any) {
        if (!this.services[constructor]) {
            this.services[constructor] = {
                key: constructor.name.toString(),
                alive: 0,
                dead: 0
            };
        }

        this.services[constructor].alive++;
    }

    private removeInstance(constructor: any) {
        this.services[constructor].alive--;
        this.services[constructor].dead++;

        // if (!this.services[constructor].alive) {
        //     delete this.services[constructor];
        // }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/diagnostics.service.ts